import type { TFaceReferencePreview } from '@vlabs/monokit/entities/matcher/types/types';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { routes } from '@vlabs/shared/navigation/routes';
import { formatDateTime } from '@vlabs/shared/utils/date';
import { FaceSample, Control, Tooltip } from '@vlabs/uikit';
import { generatePath } from 'react-router-dom';

import st from './FacePreview.module.sass';
import { useSearchApi } from '../../../../api/SearchApiProvider';
import { useApiData } from '../../../../api/useApiData';
import { useSearchPageTranslation } from '../../../../i18n';

export interface FacePreviewProps {
  reference: TFaceReferencePreview;
}

export function FacePreview({ reference }: FacePreviewProps): JSX.Element | null {
  const { t } = useSearchPageTranslation();
  const api = useSearchApi();
  const { data: listOptions = [] } = useApiData(api.getListOptions);
  if (!reference) return null;

  return (
    <div
      className={st.Root}
      data-testid="table.facePreview"
    >
      <FaceSample
        className={st.Sample}
        size="large"
        src={reference.uiAvatarURL}
      />
      <div
        className={st.Info}
        data-testid="search.preview.faceInfo"
      >
        <div className={st.Title}>{t('reference_selector.face_preview.info.created')}</div>
        <div>{formatDateTime(reference.create_time)}</div>
        <div className={st.Title}>{t('reference_selector.face_preview.info.lists')}</div>
        <div>
          {reference.lists?.map((listId) => (
            <Control.Link
              key={listId}
              kind="secondary"
              // @ts-expect-error требуется типизация routes
              to={generatePath(routes.lists.read, { listId })}
            >
              {listOptions.find((l: Option) => l.value === listId)?.label ?? listId}
            </Control.Link>
          ))}
        </div>
        <div className={st.Title}>{t('reference_selector.face_preview.info.face_id')}</div>
        <Tooltip
          clickable
          tooltipContent={reference.face_id}
        >
          <div className={st.FaceId}>{reference.face_id}</div>
        </Tooltip>
        <div className={st.Title}>{t('reference_selector.face_preview.info.user_data')}</div>
        <div>{reference.user_data || ' - '}</div>
      </div>
    </div>
  );
}
